<template>
  <div class="award-container">
    <div class="award-container__wrapper" v-if="renderAwards.length > 0">
      <div class="award__title scrollObj">awards</div>
      <template v-if="$bowser.mobile">
        <div class="award__group-year-choose scrollObj" @click="resort">
          <p class="title">
            {{ currentShowYearIndex > 0 && yearLists.length > 0 ? selectedYear : "year" }}
          </p>
        </div>
      </template>
      <div class="award__group">
        <div
          class="group__box"
          v-for="(group, index) in renderAwards"
          :key="index"
          :data-year="group.year"
          ref="awardGroup"
        >
          <div class="group__title scrollObj" ref="fixtedTitle">
            <i class="line"></i>
            <p>{{ group.year }}</p>
          </div>
          <div class="group__lists-container">
            <div
              class="group__list-wrapper"
              @mousemove="!$bowser.mobile && groupMouseMove($event)"
              @mouseleave="groupMouseLeave"
            >
              <div
                class="group-list__item scrollObj"
                v-for="(item, i) in group.lists"
                :key="i"
                :data-img="item.project.cover"
                ref="listItems"
                @click="onJump(item.project)"
              >
                <div class="item__text">
                  <p class="text__title">{{ item.name }}</p>
                  <div class="text__name">
                    <p>
                      <strong v-if="$bowser.mobile">{{ group.year }}</strong>
                      {{ item.project.name.cn }}
                    </p>
                    <i class="icon"></i>
                  </div>
                </div>
              </div>
              <div class="groud-list-cover">
                <img v-if="inView" :src="inView.dataset.img" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- award-logo -->
        <div class="earn-award-logo-container">
          <div class="award-logo__inner">
            <div class="award__item scrollObj" v-for="(logo, index) in logos" :key="index">
              <img :src="logo" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer class="award-footer"></page-footer>
    <van-popup v-model="showPicker" class="popup-container" position="bottom">
      <van-picker
        title="Year"
        show-toolbar
        :columns="yearLists"
        class="picker-container"
        @confirm="onPickerConfirm"
        @cancel="onPickerCancel"
      ></van-picker>
    </van-popup>
  </div>
</template>

<script>
import 'vant/lib/index.css';
import { awards } from '@/utils/data';
import pageFooter from '../common/footer.vue';
// 导入所有奖项
const req = require.context('@/assets/images/prizes', false, /\.jpg$/);
const prizes = req.keys().map((item) => req(item));

const screenHeight = window.innerHeight;

export default {
  name: 'page-award',
  components: {
    pageFooter,
  },
  data() {
    return {
      awards: null,
      renderAwards: [],
      currentYear: null,
      fixedOffsetTop: 0,
      isTriggerScroll: false,
      mousePos: {
        x: 0,
        y: 0,
      },
      currenWrapper: null,
      logos: prizes,
      currentShowYearIndex: -1,
      yearLists: ['全部'],
      showPicker: false,
    };
  },
  watch: {
    currenWrapper(val) {
      if (val) {
        val.querySelector('.groud-list-cover').style.display = 'block';
      } else {
        document.querySelectorAll('.groud-list-cover').forEach((item) => {
          item.style.cssText = 'top:0;left:0;display:none;';
        });
      }
    },
    mousePos(val) {
      const { style } = this.currenWrapper.querySelector('.groud-list-cover');
      style.top = `${val.y}px`;
      style.left = `${val.x + 30}px`;
    },
    currentShowYearIndex(val) {
      val = Number(val);
      this.renderAwards = val > 0 ? this.awards.filter((item, index) => Number(index) === val - 1) : this.awards;
      this.pageInit();
    },
  },
  computed: {
    selectedYear() {
      const year = this.yearLists.find(
        (item, index) => Number(index) === Number(this.currentShowYearIndex),
      );
      return year;
    },
    offsetTop() {
      return this.$refs.fixtedTitle.getBoundingClientRect().top || 0;
    },
    inView() {
      let inView;
      if (this.currenWrapper) {
        const bcr = this.currenWrapper.getBoundingClientRect();
        const { y } = this.mousePos;
        inView = this.$refs.listItems.find((item) => {
          const el = item;
          const currentBcr = el.getBoundingClientRect();
          const currentTop = currentBcr.top - bcr.top;
          return currentTop <= y && currentTop + currentBcr.height >= y;
        });
      }
      // return inView ? inView.$el : null;
      return inView || null;
    },
  },
  mounted() {
    console.log(this.logos);
  },
  destroyed() {
    if (this.isTriggerScroll) {
      window.removeEventListener('scroll');
    }
  },
  beforeRouteEnter(to, from, next) {
    awards().then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  beforeRouteUpdate() {},
  methods: {
    onScroll() {
      this.isTriggerScroll = true;
      const current = this.$refs.awardGroup.find((item) => {
        const bcr = item.getBoundingClientRect();
        const bottom = bcr.top + bcr.height;
        return bcr.top < screenHeight && bottom > this.offsetTop * 1.2;
      });
      this.currentYear = current.dataset.year;
    },
    groupMouseMove(el) {
      this.currenWrapper = el.currentTarget;
      const bcr = this.currenWrapper.getBoundingClientRect();
      const y = el.clientY - bcr.top;
      this.mousePos = {
        x: el.clientX - bcr.left,
        y,
      };
    },
    groupMouseLeave() {
      this.currenWrapper = null;
    },
    resort(el) {
      const that = this;
      const target = el.currentTarget;
      if (target.classList.contains('actived')) {
        target.classList.remove('actived');
      } else {
        target.classList.add('actived');
      }
      that.showPicker = !that.showPicker;
    },
    setData(data) {
      this.awards = data;
      this.renderAwards = this.awards;
      const yearLists = data.map((item) => item.year);
      this.yearLists.push(...yearLists);
      this.currentYear = this.renderAwards['0'].year;
    },
    onPickerConfirm(...args) {
      this.currentShowYearIndex = args['1'];
      this.closePicker();
    },
    onPickerCancel() {
      this.currentShowYearIndex = -1;
      this.closePicker();
    },
    closePicker() {
      this.showPicker = false;
    },
    onJump(item) {
      if (item.id > 0) {
        this.$router.push({
          path: `/product/${encodeURIComponent(item.name.en)}/${item.id}`,
        });
      }
    },
  },
};
</script>

<style></style>
